













import { Component, Vue } from "vue-property-decorator";
import PageResult from "@/components/PageResult.vue";
import {formatMessage} from "@/locale"

@Component({
  components: {
    "v-page-result": PageResult
  }
})
export default class App extends Vue {
  icon: any = require("./assets/images/ic_fail.png");
  msg: string = formatMessage({id:"message.common.notFound"});

  mounted() {
    
  }

  get invalidRoute(): boolean {
    const invalid = !this.$route.matched || this.$route.matched.length === 0;

    return invalid;
  }
}
